// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3FPXh","large":"styles_large__DfjRA"};